class ComponentForm {
  constructor() {
    this._init();
  }

  // Fonction pour vérifier tous les inputs d'un coup
  // public refreshFieldsState(container: HTMLElement | Document = document) {
  //   const inputs = container.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('form input, form textarea');
  //   inputs.forEach(input => this.checkInput(input));
  // }

  // private checkInput(input: HTMLInputElement | HTMLTextAreaElement) {
  //   const parent = input.closest('.contact-form__item');
  //   if (input.value.trim() !== '') {
  //     input.classList.add('filled');
  //     parent?.classList.add('focused');
  //   } else {
  //     input.classList.remove('filled');
  //     parent?.classList.remove('focused');
  //   }
  // }

  _init() {
    window.addEventListener('load', () => {
      // const inputs = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('form input, form textarea');

      // inputs.forEach((input) => {
      //   // Vérification au chargement + délai auto-fill
      //   this.checkInput(input);
      //   setTimeout(() => this.checkInput(input), 100);

      //   input.addEventListener('focus', () => {
      //     input.closest('.contact-form__item')?.classList.add('focused');
      //   });

      //   input.addEventListener('blur', () => {
      //     this.checkInput(input);
      //   });

      //   // Important : détecter quand la valeur change sans focus (JS ou remplissage)
      //   input.addEventListener('input', () => this.checkInput(input));
      // });

      // // Cas 1 : Succès de l'envoi (on vide tout)
      // document.addEventListener('wpcf7mailsent', (event) => {
      //   const form = event.target as HTMLFormElement;
      //   const formInputs = form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      //   formInputs.forEach(input => {
      //     input.classList.remove('filled');
      //     input.closest('.contact-form__item')?.classList.remove('focused');
      //   });
      // });

      // // Cas 2 : Échec de l'envoi (champs de nouveau pré-remplis avec erreurs)
      // // On écoute 'wpcf7submit' qui est déclenché à chaque tentative, succès ou échec
      // document.addEventListener('wpcf7submit', (event) => {
      //   // On attend un tout petit peu que CF7 remette les valeurs en place
      //   setTimeout(() => {
      //     const form = event.target as HTMLFormElement;
      //     this.refreshFieldsState(form);
      //   }, 50);
      // });

      // Password
      const passwordTogglers = document.querySelectorAll('.password-toggle');

      passwordTogglers.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const input = btn.parentElement?.querySelector('input');

          if (input) {
            const isPassword = input.type === 'password';
            input.type = isPassword ? 'text' : 'password';
            btn.classList.toggle('is-visible', isPassword);
            btn.setAttribute('aria-label', isPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
          }
        });
      });
    });
  }
}

export const componentForm = new ComponentForm();